import api from './api';

const API_SCOPE = 'api://6069b616-c7f2-4978-9f9c-180ec12f1844/access_as_user';

async function getAnalyticsToken(msalInstance) {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) throw new Error('No authenticated account');
  try {
    const resp = await msalInstance.acquireTokenSilent({
      scopes: [API_SCOPE],
      account: accounts[0],
    });
    return resp.accessToken;
  } catch {
    const resp = await msalInstance.acquireTokenPopup({
      scopes: [API_SCOPE],
    });
    return resp.accessToken;
  }
}

export async function fetchMoleculeList(msalInstance, params = {}) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/analytics/molecule', {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchMoleculeDetail(msalInstance, inn) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/analytics/molecule', {
    params: { inn },
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchPredictive(msalInstance, params = {}) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/analytics/predictive', {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchNlGap(msalInstance, params = {}) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/analytics/nl-gap', {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchTherapeuticArea(msalInstance, params = {}) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/analytics/therapeutic-area', {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchPharmaceuticalForm(msalInstance, params = {}) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/analytics/pharmaceutical-form', {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function generateNovaReport(msalInstance, { reportType, format, filters, language }) {
  const token = await getAnalyticsToken(msalInstance);
  const body = { reportType, format, filters };
  if (language) body.language = language;
  const { data } = await api.post('/api/nova/report', body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function downloadNovaReport(msalInstance, reportId) {
  const token = await getAnalyticsToken(msalInstance);
  // reportId format: {userOid}/{reportType}/{filename}
  const parts = reportId.split('/');
  const reportType = parts[1];
  const filename = parts.slice(2).join('/');
  const resp = await api.get(`/api/nova/outputs/${reportType}/${encodeURIComponent(filename)}/download`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
  return resp.data;
}

export async function fetchSupplierPortfolio(msalInstance, params = {}) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/analytics/supplier-portfolio', {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function fetchSupplierScores(msalInstance) {
  const token = await getAnalyticsToken(msalInstance);
  const { data } = await api.get('/api/supplier-scores', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}
